<template>
  <div class="dry-power">
    <moduleTitle title="基本信息"></moduleTitle>
    <div class="dry-power-content">
      <!-- <div>
        <img :src= xinxiData.img  class="ingBox" />
      </div> -->
      <div class="xinxi">
        <img :src="xinxiData.img" class="imgBox" />
        <div class="pBox">
          <p>
            {{ xinxiData.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleTitle from './components/moduleTitle.vue';
import { getBasicInfo } from '@api/njfw/njfw.js';

export default {
  components: {
    moduleTitle
  },
  created () {
    this.getList();
  },
  data () {
    return {
      xinxiData: ''
    };
  },
  methods: {
    getList () {
      getBasicInfo({})
        .then(res => {
          this.xinxiData = res.data[0];
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@function companyW($num) {
  @return ($num * 100)/1920;
}
@function companyH($num) {
  @return ($num * 100)/1080;
}
* {
  font-family: Source Han Sans CN;
  color: #f0f6f5;
  font-size: companyW(20vw);
  box-sizing: border-box;
}
.dry-power {
  position: relative;
  width: companyW(482vw);
  height: companyH(338vh);
  background: rgba(0, 20, 36, 0.2);
  border: companyW(1vw) solid;
  border-image: linear-gradient(0deg, #6d8a94, #6d8a94) 10 10;
  // opacity: 0.74;
  .dry-power-content {
    margin: 0 auto;
    margin-top: companyH(40vh);
    width: companyW(422vw);
    .xinxi {
      max-height: companyH(290vh);
      overflow: auto;
    }
    .imgBox {
      width: companyW(202vw);
      height: companyH(127vh);
      margin-right: 10px;
      text-align: justify; /* 两端对齐 */
      float: left;
    }

    p {
      font-size: companyW(18vw);
      color: #fff;
      line-height: companyH(34vh);
      text-align: justify; /* 两端对齐 */
    }
  }
}
.xinxi::-webkit-scrollbar {
  width: 5px; /* 设置滚动条的宽度 */
  // height: 10px; /* 设置滚动条的高度 */
  // background-color: #F5F5F5; /* 设置滚动条的背景色 */
  // border-radius: 5px; /* 设置滚动条的圆角 */
}
</style>
